export const profile = {
    name: 'Ruddy Riina',
    headline: 'Imagine and Realize',
    // Scrambled in one after the other under the headline.
    taglines: ['Code', 'Design', 'UI/UX', 'Artificial Intelligence', 'Web App', 'Mobile App', 'Desktop App', 'Website'],
    avatar: {
        src: '/img/avatar.jpg',
        lazySrc: '/img/avatar-lazy.jpg',
    },
    cvUrl: '/files/ruddy_riina_cv.pdf',
};

export const socials = [
    { name: 'Facebook', icon: 'mdi-facebook', url: 'https://www.facebook.com/r2rii' },
    { name: 'LinkedIn', icon: 'mdi-linkedin', url: 'https://www.linkedin.com/in/ruddy-riina-a82134165/' },
];

export const contact = {
    address: ['Antananarivo, Madagascar', 'Immeuble Jacaranda', 'Bureau N-1'],
    phone: { label: '+261 38 08 595 55', href: 'tel:+261380859555' },
    email: 'ruddyriina@gmail.com',
};
